import React from 'react';
import ImageUploader from './ImageUploader';

export default class InputControl extends React.PureComponent {
  state = {
    value: this.props.value,
  };

  render() {
    switch (this.props.reactInputControl) {
      case 'ImageUploader':
        return <ImageUploader {...this.props} />;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/containers/InputControls/index.js